import { type ReactNode } from 'react';
import { PaymentMethod, PaymentRequestTableRecord, SuccessfulPaymentMethodType } from '@mews-commander/data-access';
import { PaymentMethodImageType } from '@mews/business-components';
import { PaymentCardType } from '@mews/enums';
import { LocalizedEnum } from '@mews/framework';
import { PaymentMethodIcon } from '../../../../../components/commander-ui/PaymentMethodIcon';
import PaymentCardIcon from '../../../../../components/commander-ui/PaymentCardIcon';

export const comparePaymentRequestByCreatedUtc = (a: PaymentRequestTableRecord, b: PaymentRequestTableRecord): number =>
    a.createdUtc.localeCompare(b.createdUtc);

export const mapToSupportedPaymentMethod = (type: SuccessfulPaymentMethodType): PaymentMethod | null => {
    switch (type) {
        case SuccessfulPaymentMethodType.CreditCard:
            return PaymentMethod.PaymentCard;
        case SuccessfulPaymentMethodType.SepaDirectDebit:
            return PaymentMethod.SepaDirectDebit;
        default:
            return null;
    }
};

export const getPaymentMethodIcon = (
    paymentMethodType: SuccessfulPaymentMethodType,
    creditCardType?: PaymentCardType | null
): ReactNode => {
    if (paymentMethodType === SuccessfulPaymentMethodType.CreditCard && creditCardType) {
        return <PaymentCardIcon type={creditCardType} width={24} />;
    }

    const iconTypeMap: Record<SuccessfulPaymentMethodType, PaymentMethodImageType> = {
        [SuccessfulPaymentMethodType.SepaDirectDebit]: PaymentMethodImageType.SepaDirectDebit,
        [SuccessfulPaymentMethodType.ApplePay]: PaymentMethodImageType.ApplePay,
        [SuccessfulPaymentMethodType.GooglePay]: PaymentMethodImageType.GooglePay,
        [SuccessfulPaymentMethodType.Ideal]: PaymentMethodImageType.Ideal,
        [SuccessfulPaymentMethodType.CreditCard]: PaymentMethodImageType.PaymentCard,
    };

    return <PaymentMethodIcon type={iconTypeMap[paymentMethodType]} small />;
};

export const getPaymentMethodTitle = (
    paymentMethodType: SuccessfulPaymentMethodType,
    creditCardType?: PaymentCardType | null
): ReactNode => {
    if (paymentMethodType === SuccessfulPaymentMethodType.CreditCard && creditCardType) {
        return <LocalizedEnum prefix="PaymentCardType" value={creditCardType} />;
    }

    return <LocalizedEnum prefix="SuccessfulPaymentMethodType" value={paymentMethodType} />;
};
